<template>
  <v-card elevation="0" tile :color="bg_color" class="mx-5">
    <v-container class="py-0">
      <v-row justify="center">
        <v-card elevation="0" tile class="px-0" width="1200" :color="bg_color">
          <v-fab-transition>
            <v-btn
              :color="theme_color"
              dark
              absolute
              top
              left
              fab
              :x-large="!isSmall"
            >
              <v-icon color="white">{{ main_icon }}</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-card-text>
            <v-list class="mb-10" :color="bg_color">
              <v-subheader class="px-0 mx-0 mt-5">
                <v-row justify="center" class="px-0 mx-0">
                  <v-col cols="4">
                    <span
                      :class="
                        isSmall
                          ? theme_text_color + ' subtitle-1'
                          : theme_text_color + ' title'
                      "
                    >
                      Selected Talks
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>

                  <v-col cols="3">
                    <span class="subtitle-1"> Topic </span></v-col
                  >
                  <!-- <v-col cols="3">
                    <span class="subtitle-1">  </span></v-col
                  > -->
                </v-row></v-subheader
              >
              <v-list-item-group active-class="border" :color="theme_color">
                <v-list-item
                  v-for="(item, index) of conferences"
                  :key="index"
                  class="pa-0"
                >
                  <v-row justify="center" class="px-0 mx-0 py-4">
                    <v-col cols="6" align-self="center">
                      <span class="subtitle-1">{{ item.name }}</span>
                    </v-col>
                    <v-col cols="6" align-self="center">
                      <span class="subtitle-1 font-weight-light">{{
                        item.topic
                      }}</span>
                    </v-col>
                    <!-- <v-col cols="3" align-self="center">
                      <span class="subtitle-1 font-weight-light">
                        {{ item.date }}</span
                      >
                    </v-col> -->
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider></v-divider>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "education",
  created() {
    window.addEventListener("resize", this.cal_window);
  },
  destroyed() {
    window.removeEventListener("resize", this.cal_window);
  },
  mounted() {
    this.cal_window();
  },
  methods: {
    cal_window() {
      this.isSmall = window.innerWidth < 1264 ? true : false;
    },
  },
  data: () => ({
    main_icon: "mdi-presentation",
    bg_color: "grey lighten-5",
    theme_color: "indigo lighten-2",
    theme_text_color: "indigo--text text--darken-1",
    isSmall: false,
    conferences: [
      {
        name: "Global Emissions InitiAtive (GEIA), 2023",
        topic: "Building Integral Gridded Carbon Emission Disaggregation Model Framework (BIGCarbon): From Building Features, Satellite Image, Machine Learning To Fine Gridded CO2 Emissions Map in Near-real Time (Poster)",
        // date: "2018",
      },  
      {
        name: "European Geosciences Union General Assembly (EGU), 2023",
        topic: "Building Integral Gridded Carbon Emission Disaggregating Model (BIGCarbon): Near real-time community-level CO2 emission evaluations for twelve cities in Egypt, South Africa, and Turkey (Talk)",
        // date: "2018",
      },  
      {
        name: "European Climate and Energy Modelling Forum (ECEMP), 2022",
        topic: "Can Russian gas be replaced for the post Ukraine crisis period? (Talk)",
        // date: "2018",
      },      
      {
        name: "Integrated Carbon Observation System (ICOS), 2022",
        topic: "Supply-consumption simulations of natural gas in the European Union (EU) countries: Can Russian gas be replaced for the post Ukraine crisis period? (Plenary Talk)",
        // date: "2022",
      },      
      {
        name: "International Association for Great Lakes Research (IAGLR), 2018",
        topic: "Legacy polybrominated diphenyl ethers (PBDEs) trends in top predator fish of the Laurentian Great Lakes (GL) from 1979 to 2016: Will concentrations continue to decrease? (Poster)",
        // date: "2018",
      },
      {
        name:
          "International Conference on Mercury as a Global Pollutant (ICMGP), 2017",
          topic: "Mercury temporal trends in top predator fish of the Laurentian Great Lakes from 2004 to 2015: are concentrations still decreasing? (Talk)",
        // date: "2017",
      },
      {
        name:
          "International Conference on Mercury as a Global Pollutant (ICMGP), 2017",
          topic: "TraPSA: Trajectory-based Potential Sourece Apportionment Project (Poster)",
        // date: "2017",
      },
      {
        name: "International Association for Great Lakes Research (IAGLR), 2017",
        topic: "Mercury temporal trends in top predator fish of the Laurentian Great Lakes from 2004 to 2015 with concentrations normalized with fish age (Talk)",
        // date: "2017",
      },
      // {
      //   name: "International Association for Great Lakes Research (IAGLR) 2016",
      //   topic: "Poster",
      //   // date: "2016",
      // },
      // {
      //   name: "Dioxin 2016",
      //   topic: "Poster",
      //   // date: "2016",
      // },
    ],
  }),
};
</script>
<style scoped>
/* div {
  outline: 1px dashed blue;
} */
</style>

